export const GUILD_API_ENDPOINT: string | undefined = process.env.REACT_APP_GUILD_API_URL
export const NOTIFICATION_API_ENDPOINT: string | undefined = process.env.REACT_APP_NOTIFICATION_API_URL
export const ITEMLIST_API_ENDPOINT: string | undefined = process.env.REACT_APP_ITEMLIST_API_URL
export const SEARCH_API_ENDPOINT: string | undefined = process.env.REACT_APP_SEARCH_API_URL
export const EXTRACT_API_ENDPOINT: string | undefined = process.env.REACT_APP_EXTRACT_API_URL
export const SEARCH_MAX_RESULT_TO_EXPORT_EXCEL: number | undefined = 100

